import { Component, forwardRef, Input, OnInit, } from '@angular/core';
import { IOptionWithIcon } from '../models/option';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { materialSymbols } from '../../../shared/constants/material-symbols';

@Component({
    selector: 'app-segmented-button',
    templateUrl: './segmented-button.component.html',
    styleUrl: './segmented-button.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SegmentedButtonComponent),
            multi: true
        }
    ],
    standalone: false
})
export class SegmentedButtonComponent<T> implements ControlValueAccessor{
  disabled: boolean = false;

  @Input() id: string = '';
  @Input() buttonOptions: IOptionWithIcon<T>[] = [];
  @Input() class: string = '';
  
  onChange: (value: T[]) => void = () => { };
  onTouched: any = () => { };

  multiSelect: boolean = false;
  materialSymbol = materialSymbols;
  values: T[] = [];

  writeValue(obj: T[]): void {
    // This method is called by the forms API to write to the view when programmatic changes from model to view are requested.
    this.values = obj;
  }
  registerOnChange(fn: any): void {
    // This method is called by the forms API on initialization to update the form model when values propagate from the view to the model.
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    // Registers a callback function that is called by the forms API on initialization to update the form model on blur.
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    // Function that is called by the forms API when the control status changes to or from 'DISABLED
    this.disabled = isDisabled;
  }

  onButtonClick(buttonValue: T): void {
    let newValues : T[] = [];

    if(this.multiSelect) {
      if (this.values.includes(buttonValue)) {
        newValues = this.values.filter(v => v !== buttonValue);
      } else {
        newValues = [...this.values, buttonValue];
      }
    } else {
      newValues = [buttonValue];
    }
    
    this.values = newValues;
    this.onChange(newValues);
  }
}
